Vue.component('attribute-icon', {
    template: '#vue-attribute-icon',
    props: ['attribute']
});

Vue.component('attributes', {
    template: '#vue-attributes',
    props: ['attributes']
});